import React, { FC } from 'react';

import { SobannerProps } from './models';
import {
  ArticleContainerVariant,
  DefaultContainerVariant,
  GridContainerVariant,
  PageContainerVariant,
  PopupContainerVariant,
  SliderContainerVariant,
  VideoContainerVariant,
} from './variants/containers';

import './SoBanner.scss';

const SoBanner: FC<SobannerProps> = ({ data }) => {
  const { variant } = data;
  switch (variant[0]) {
    case 'grid':
      return <GridContainerVariant data={data} />;
    case 'page':
      return <PageContainerVariant data={data} />;
    case 'popup':
      return <PopupContainerVariant data={data} />;
    case 'slider':
      return <SliderContainerVariant data={data} />;
    case 'video':
      return <VideoContainerVariant data={data} />;
    case 'article':
      return <ArticleContainerVariant data={data} />;
    default:
      return <DefaultContainerVariant data={data} />;
  }
};

export default SoBanner;
